var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('h1',{staticClass:"bootup"},[_vm._v("Welcome to Celus")]),_c('LoaderWidget',{attrs:{"text":_vm.$t(_vm.bootUpMessage),"height":"300px","padding-top":"80px","max-width":"400px"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bootup-logo"},[_c('img',{attrs:{"src":require("../assets/celus-plus-white-vertical-nobg.svg"),"height":"158","alt":"Celus Logo"}})])
}]

export { render, staticRenderFns }